module.exports = __webpack_public_path__ + "img/pt-19.1ae0db17.jpg";